<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    :disabled="loading"
    @submit.prevent="() => submitForm()"
  >
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <password-field
            label="Senha atual"

            name="password"
            required

            v-model="formFields.currentPassword"
            :rules="[vRules.requiredField]"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <password-field
            label="Nova senha"

            name="new-password"
            required

            v-model="formFields.newPassword"
            :rules="[vRules.requiredField]"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <password-field
            label="Confirme a nova senha"

            name="password-confirmation"
            required

            v-model="formFields.passwordConfirmation"
            :rules="[vRules.requiredField]"
            :error-messages="passwordConfirmationErrorBag"
          />
        </v-col>
      </v-row>

      <v-row dense justify="end">
        <v-col cols="12" sm="auto">
          <v-btn
            block
            color="primary"
            type="submit"

            :loading="loading"
            :disabled="!isFormValid"
          >
            Atualizar senha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { requiredField } from '@/utils/validators';
import PasswordField from '@/components/PasswordField.vue';

export default {
  name: 'UpdatePasswordForm',

  components: {
    PasswordField,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isFormValid: false,

    formFields: {
      currentPassword: '',
      newPassword: '',
      passwordConfirmation: '',
    },

    vRules: {
      requiredField,
    },
  }),

  computed: {
    passwordConfirmationErrorBag: (vm) => {
      const errorBag = [];
      const { newPassword, passwordConfirmation } = vm.formFields;

      if (passwordConfirmation && newPassword !== passwordConfirmation) {
        errorBag.push('As senhas digitas devem ser iguais.');
      }

      return errorBag;
    },
  },

  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formFields });
    },
  },
};
</script>
